var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('click-button',{staticClass:"view-icon-button",attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"icon":_vm.icon,"theme":_vm.theme,"color":_vm.color,"callback":_vm.callback}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e72334ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/IconButton.vue
// module id = 271
// module chunks = 0